import MoleculeForm from "./MoleculeForm.js"; // Import MoleculeForm component
import StatsBox from "../StatsPage/StatsBox.js";
import SubmitInputField from "./submitInputField.js";
import { useState } from "react";
import axios from "../../api/axios.js";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import MechanismSelectionButton from "./MechanismSelectionButton.js";
import renderMechanism from "../../api/renderMechanism.js";
import MechanismForm from "./MechanismFormGrid.js";
import ResultInfoText from "../ResultsTable/ResultInfoText.js";
import SubmitCreatableSelect from "./SubmitCreatableSelect.js";


export default function ReactionForm({ reaction, onChange, setMechanismBody, mechanismTypes, evidenceTypes, getPrevPublication = () => { return {publication: "", doi: ""}; }, knownConditionTags = [], sessionMechanismSources = [] }) {

  const [mechanismSelection, setMechanismSelection] = useState([]);
  const [mechanismMessage, setMechanismMessage] = useState("");
  const [definingMechanism, setDefiningMechanism] = useState(false);

  
  const handleFieldChange = (e) => {
    console.log(e);

    const { name, value } = e.target;
    if (name == "conditionTags") {
      console.log(e.e);
      let new_tags = e.e.map(item => item.value).join(",");
      onChange({ ...reaction, [name]: new_tags });
      return;
    }
    onChange({ ...reaction, [name]: value });
  };

  const handleMoleculeChange = (index, updatedMolecule, type) => {
    if (type === "substrate") {
      onChange({ ...reaction, substrates: reaction.substrates.map((s, i) => (i === index ? updatedMolecule : s)) });
    } else {
      onChange({ ...reaction, product_mol: updatedMolecule });
    }
  };

  const addSubstrate = () => {
    onChange({ ...reaction, substrates: [...reaction.substrates, { molecule_id: null, smiles: "", name: "", marts: "", chebi: "" }] });
  }
  const removeLastSubstrate = () => {
    if (reaction.substrates.length === 1) {
      return;
    }
    onChange({ ...reaction, substrates: reaction.substrates.slice(0, -1) });
  }

  const handleMechanismChange = (mechanismSteps) => {
    onChange({ ...reaction, mechanism: mechanismSteps });
  };

  const finalMechanismStepChange = (field, value) => {
    onChange({ ...reaction, [field]: value });
  }

  /*
   * A copied mechanism can bring its evidence and publication along, so all of it
   * has to land in a single reaction update - separate calls would each build on
   * the same stale `reaction` and only the last field would stick.
   */
  const applyMechanismCopy = (mechanismSteps, extras = {}) => {
    const updated = { ...reaction, mechanism: mechanismSteps };
    if (extras.evidence) updated.final_mech_evidence = extras.evidence;
    if (extras.publication) updated.mechanism_publication = extras.publication;
    if (extras.doi) updated.mechanism_doi = extras.doi;
    onChange(updated);
  }


  async function selectKnownMechanism() {
    let allMoleculesHaveMarts = true;
    reaction.substrates.forEach((substrate) => {
      if (!/^marts_[ERM][0-9]{5}$/.test(substrate.marts)) {
        allMoleculesHaveMarts = false;
      }
    });
    if (!/^marts_[ERM][0-9]{5}$/.test(reaction.product_mol.marts)) {
      allMoleculesHaveMarts = false;
    }
    if (!allMoleculesHaveMarts) {
      setMechanismMessage("All molecules must exist in the database to select a known mechanism");
      return;
    }
    const req = { 
      substrates: reaction.substrates.map((substrate) => substrate.marts),
      product: reaction.product_mol.marts,
      requestType: "mechanism"
    }
    const response = await axios.post("/submitcheck", req)
    console.log(response.data);
    if (typeof response.data === 'object' && response.data){
     
      setMechanismSelection(response.data);
    }
    else{
      setMechanismMessage("No known mechanisms");
    }
  }

  const selectMechanism = (id) => {
    setMechanismMessage("Mechanism " + id +  " selected");
    onChange({ ...reaction, mechanism_marts: id });
  }

  async function renderSelectedMechanism(marts_id){
    console.log(marts_id);
      const res = await renderMechanism({table: null, row: null, isQuickSearch: false, showPopups: false, mechanismUnclicked: false, mechanism_marts_id: marts_id, setMechBody: setMechanismBody});
  }

  const defineMechanism = () => {
    setDefiningMechanism(true);
  }

  const selectPreviousPublication = () => {
    const prevPub = getPrevPublication();
    onChange({ ...reaction, reaction_link: prevPub.publication, reaction_doi: prevPub.doi });
  }

  return (

    <div>
        <StatsBox title={
            <><ResultInfoText text="Reaction" row={1} fontSize="24px" buttonClass="plane-text-button-no-background"/></>} backgroundColor="RGB(253, 253, 253)" >
        {reaction.is_new ? (
          <p>Define substrate, product and additional information for your reaction.</p>
        ) : (
          <p>This reaction is from the database. You can define a new mechanism for it.</p>
        )}
        <SubmitInputField name="type" value={reaction.type} onChange={handleFieldChange} label="Type" disabled={!reaction.is_new} tooltip="The terpene type of the reaction. Use the type prefix e.g. mono for monoterpenes. Isoprenyl diphosphate synthases and prenyl transferases should use pt as type. Meroterpenoids use mero." placeholder="di"/>
        <SubmitInputField name="class" value={reaction.class} onChange={handleFieldChange} label="Class" disabled={!reaction.is_new} tooltip="Write the class in arabic numbers" placeholder="1" />
        <SubmitInputField name="publication" value={reaction.publication} onChange={handleFieldChange} label="Publication link" disabled={!reaction.is_new} tooltip="Enter a link to a paper or other source for this reaction. " placeholder="https://www.nature.com/articles/s41589-022-01026-2"/>
        <SubmitInputField name="publicationdoi" value={reaction.publicationdoi} onChange={handleFieldChange} label="Publication DOI" disabled={!reaction.is_new} tooltip="Enter the DOI of the source of this reaction. This is the prefered way of entering source." placeholder="https://doi.org/10.1038/s41589-022-01026-2"/>
        <SubmitInputField name="abundance" value={reaction.abundance} onChange={handleFieldChange} label="Product ratio" disabled={!reaction.is_new} tooltip="Enter the ratio of this product, the possible values are described on the help page." placeholder="major"/>
        Mechanism: {reaction.mechanism_marts}
        <SubmitCreatableSelect label={"Condition tags"} options={knownConditionTags.map(value => ({ value, label: value }))} onChange={handleFieldChange} placeholder="condition" target="conditionTags" value={reaction.conditionTags ? reaction.conditionTags.split(",").map(value => ({ value, label: value })) : []} isMulti={true} />

      <div style={{ display: "flex", flexDirection: "row", gap: "16px", alignItems: "flex-start", flexWrap: "wrap" }}>
        <div style={{ flex: 1, minWidth: "280px" }}>
          {reaction.substrates.map((substrate, index) => (
            <MoleculeForm
              key={index}
              title_text={`Substrate ${index + 1}`}
              molecule={substrate}
              onChange={(updatedMolecule) => handleMoleculeChange(index, updatedMolecule, "substrate")}
              disabled={!reaction.is_new}
              moleculeId_start={substrate.molecule_id}
              backgroundColor="RGB(250, 250, 250)"
            />
          ))}
          <button
            class="basic-button"
            onClick={addSubstrate}
            disabled={!reaction.is_new}
          >
            Add Substrate
          </button>
          <button
            class="basic-button"
            onClick={removeLastSubstrate}
            disabled={!reaction.is_new || reaction.substrates.length <= 1}
          >
            Remove Substrate
          </button>
        </div>
        <div style={{ flex: 1, minWidth: "280px" }}>
          <MoleculeForm
            key={0}
            molecule={reaction.product_mol}
            onChange={(updatedMolecule) => handleMoleculeChange(0, updatedMolecule, "product")}
            title_text={"Product"}
            disabled={!reaction.is_new}
            moleculeId_start={reaction.product_mol.molecule_id}
            backgroundColor="RGB(250, 250, 250)"
            tooltips={{
              smiles: "Enter the SMILES of your molecule. If left empty the submission is considered a negative result for the enzyme.",
              name: "Enter the most commonly used name for this molecule. If left empty unnamed intermediate or molecule is used instead.",
              chebi: "If this molecule exists in ChEBI database the ID can be linked. It is recommended to deposit any new molecule to ChEBI as well.",
              marts: "Molecules already in MARTS have Marts ID, fill in only if you want to use a molecule that is already inside the database."
            }}
          />
        </div>
      </div>
          <button
          class = "basic-button"
          onClick={selectKnownMechanism}
          >
          Select Known Mechanism
        </button>
        <button
          class = "basic-button"
          onClick={defineMechanism}
          >
          Define Mechanism
        </button>
        {mechanismMessage}
      <div>
      {mechanismSelection.map((mechanism, index) => (
        <MechanismSelectionButton key={index} marts_id={mechanism.marts_id} onClick={selectMechanism} renderFunction={renderSelectedMechanism}  />
      ))}
      {definingMechanism && (<MechanismForm substrate={reaction.substrates[0]} product={reaction.product_mol} onChange={handleMechanismChange} mechanismTypes={mechanismTypes} final_step_change={finalMechanismStepChange} evidenceTypes={evidenceTypes} sessionSources={sessionMechanismSources} mechanismMeta={{ publication: reaction.mechanism_publication, doi: reaction.mechanism_doi }} onCopyMechanism={applyMechanismCopy}/>)}


      </div>
      </StatsBox>
      </div>
  );
}